import { render, staticRenderFns } from "./task_link_dialog.vue?vue&type=template&id=ed53ba4e&scoped=true"
import script from "./task_link_dialog.vue?vue&type=script&lang=js"
export * from "./task_link_dialog.vue?vue&type=script&lang=js"
import style0 from "./task_link_dialog.vue?vue&type=style&index=0&id=ed53ba4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed53ba4e",
  null
  
)

export default component.exports